import type { ModuleId, ModuleRecord } from "../types";
import { SubscriptionBar } from "./SubscriptionBar";

interface SidebarProps {
  modules: ModuleRecord[];
  activeModule: ModuleRecord;
  activeSectionId?: string;
  expandedModuleId?: ModuleId | null;
  isOpen: boolean;
  isHomeActive: boolean;
  isLiteActive: boolean;
  onCollapse: () => void;
  onSelectHome: () => void;
  onSelectLite: () => void;
  onSelectModule: (moduleId: ModuleId) => void;
  onSelectSection: (moduleId: ModuleId, sectionId: string) => void;
}

export function Sidebar({
  modules,
  activeModule,
  activeSectionId,
  expandedModuleId,
  isOpen,
  isHomeActive,
  isLiteActive,
  onCollapse,
  onSelectHome,
  onSelectLite,
  onSelectModule,
  onSelectSection
}: SidebarProps) {
  return (
    <aside className={`sidebar ${isOpen ? "sidebar--open" : ""}`} aria-label="Navegacao do manual">
      <div className="sidebar__top">
        <div>
          <span className="eyebrow eyebrow--inverse">Manual Interativo</span>
          <h1>Medicina Intensiva</h1>
        </div>
      </div>

      <button
        className="button button--inverse sidebar__close sidebar__collapse sidebar__edge-collapse"
        type="button"
        onClick={onCollapse}
        aria-label="Minimizar sumario lateral"
        title="Minimizar sumario lateral"
      >
        <span className="sidebar__collapse-icon" aria-hidden="true" />
      </button>

      <SubscriptionBar />

      <nav className="module-nav" aria-label="Módulos">
        <button
          className={`module-nav__home ${isHomeActive ? "module-nav__home--active" : ""}`}
          type="button"
          onClick={onSelectHome}
          aria-current={isHomeActive ? "page" : undefined}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="module-nav__home-icon">
            <path d="M4 11l8-7 8 7" />
            <path d="M6 10v9h12v-9" />
            <path d="M10 19v-5h4v5" />
          </svg>
          <span>Início</span>
        </button>

        <button
          className={`module-nav__lite ${isLiteActive ? "module-nav__lite--active" : ""}`}
          type="button"
          onClick={onSelectLite}
          aria-current={isLiteActive ? "page" : undefined}
          title="Modo LITE — calculadoras"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="module-nav__lite-icon">
            <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
          </svg>
          <span>Calculadoras</span>
          <span className="module-nav__lite-tag">LITE</span>
        </button>

        {modules.map((module) => {
          const isActiveModule = !isHomeActive && module.id === activeModule.id;
          const isExpandedModule = !isHomeActive && module.id === expandedModuleId;

          return (
            <div key={module.id} className="module-nav__group">
              <button
                className={`module-nav__item ${isActiveModule ? "module-nav__item--active" : ""}`}
                type="button"
                onClick={() => onSelectModule(module.id)}
                aria-expanded={isExpandedModule}
              >
                <span>{module.number === null ? module.title : `Modulo ${module.number}`}</span>
                <strong>{module.title}</strong>
              </button>

              {isExpandedModule && module.sections.length > 0 ? (
                <div className="section-nav section-nav--inline" aria-label={module.number === null ? `Seções de ${module.title}` : `Seções do módulo ${module.number}`}>
                  {module.sections.map((section) => (
                    <button
                      key={section.id}
                      className={`section-nav__item ${
                        section.id === activeSectionId ? "section-nav__item--active" : ""
                      }`}
                      type="button"
                      onClick={() => onSelectSection(module.id, section.id)}
                    >
                      {section.title}
                    </button>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </nav>

    </aside>
  );
}
